/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Directive, ElementRef, OnInit, OnDestroy, NgZone, Renderer2} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import {ScrollDispatcher} from './scroll-dispatcher';
import'rxjs/add/observable/fromEvent';
/**
 * Sends an event when the directive's element is scrolled. Registers itself with the
 * ScrollDispatcher service to include itself as part of its collection of scrolling events that it
 * can be listened to through the service.
 */
export class Scrollable implements OnInit, OnDestroy {
private _elementScrolled: Subject<Event> = new Subject();
private _scrollListener: Function;
/**
 * @param {?} _elementRef
 * @param {?} _scroll
 * @param {?} _ngZone
 * @param {?} _renderer
 */
constructor(private _elementRef: ElementRef,
private _scroll: ScrollDispatcher,
private _ngZone: NgZone,
private _renderer: Renderer2) {}
/**
 * @return {?}
 */
ngOnInit() {
    this._scrollListener = this._ngZone.runOutsideAngular(() => {
      return this._renderer.listen(this.getElementRef().nativeElement, 'scroll', (event: Event) => {
        this._elementScrolled.next(event);
      });
    });

    this._scroll.register(this);
  }
/**
 * @return {?}
 */
ngOnDestroy() {
    this._scroll.deregister(this);

    if (this._scrollListener) {
      this._scrollListener();
      this._scrollListener = null;
    }
  }
/**
 * Returns observable that emits when a scroll event is fired on the host element.
 * @return {?}
 */
elementScrolled(): Observable<any> {
    return this._elementScrolled.asObservable();
  }
/**
 * @return {?}
 */
getElementRef(): ElementRef {
    return this._elementRef;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[cdk-scrollable], [cdkScrollable]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: ScrollDispatcher, },
{type: NgZone, },
{type: Renderer2, },
];
}

function Scrollable_tsickle_Closure_declarations() {
/** @type {?} */
Scrollable.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Scrollable.ctorParameters;
/** @type {?} */
Scrollable.prototype._elementScrolled;
/** @type {?} */
Scrollable.prototype._scrollListener;
/** @type {?} */
Scrollable.prototype._elementRef;
/** @type {?} */
Scrollable.prototype._scroll;
/** @type {?} */
Scrollable.prototype._ngZone;
/** @type {?} */
Scrollable.prototype._renderer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
